import Cookies from "js-cookie";

function switchToMode(mode) {
    if (mode === "light") {
        document.body.classList.remove("dark-mode");
        document.body.classList.add("light-mode");
    } else {
        document.body.classList.add("dark-mode");
        document.body.classList.remove("light-mode");
    }
}

export const toMode = function (el) {
    const mode = el.getAttribute("data-mode");
    switchToMode(mode);
    Cookies.set("mode", mode, {
        expires: new Date().shiftDays(365),
        path: "/",
    });
};

export const modeCookie = function (el) {
    const savedMode = Cookies.get("mode");
    if (savedMode) {
        switchToMode(savedMode);
    }
};

Date.prototype.shiftDays = function (days) {
    days = parseInt(days, 10);
    this.setDate(this.getDate() + days);
    return this;
};
